import React from 'react';
const Contact: React.FC = () => {
  return (
    <div className="w-full mx-auto">
      <div className="flex justify-center items-center">
        <h2 className="">contact</h2>
      </div>
      <div className="flex justify-center py-1em">
        <p>Email me at jon@zudell.io</p>
      </div>
    </div>
  );
};

export default Contact;
